var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "device-sync-progress", attrs: { "aria-live": "polite" } },
    [
      _vm.loading
        ? _c("p", { staticClass: "sync-muted" }, [
            _c("i", { staticClass: "el-icon-loading" }),
            _vm._v(" Đang kiểm tra tiến trình đã lưu..."),
          ])
        : _vm._e(),
      _vm.error
        ? _c("el-alert", {
            attrs: {
              title: _vm.error,
              type: "warning",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm.jobs.length
        ? _c(
            "el-form-item",
            { attrs: { label: "Tiến trình đồng bộ" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    value: _vm.job && _vm.job.id,
                    placeholder: "Chọn lượt đồng bộ để xem",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.$emit("select", $event)
                    },
                  },
                },
                _vm._l(_vm.jobs, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { value: item.id, label: _vm.jobLabel(item) },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.job
        ? [
            _c("div", { staticClass: "sync-heading" }, [
              _c("strong", [_vm._v(_vm._s(_vm.statusLabel(_vm.job.status)))]),
              _c("span", [_vm._v(_vm._s(_vm.elapsed))]),
            ]),
            _c("p", { staticClass: "sync-direction" }, [
              _vm._v(_vm._s(_vm.job.sourceName || "Thiết bị nguồn") + " "),
              _c("i", { staticClass: "el-icon-right" }),
              _vm._v(" " + _vm._s(_vm.job.targetName || "Thiết bị đích")),
            ]),
            _c("el-progress", {
              attrs: {
                percentage: _vm.job.percentage || 0,
                status: _vm.progressStatus,
                "stroke-width": 12,
              },
            }),
            _c("p", { staticClass: "sync-stage" }, [
              _vm.running
                ? _c("i", { staticClass: "el-icon-loading" })
                : _vm._e(),
              _vm._v(" " + _vm._s(_vm.stageLabel)),
              _vm.job.retryRound
                ? _c("span", [
                    _vm._v(
                      " — Vòng thử lại " + _vm._s(_vm.job.retryRound) + "/3"
                    ),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "sync-counts" }, [
              _c("div", [
                _c("span", [_vm._v("Tổng số người")]),
                _c("strong", [_vm._v(_vm._s(_vm.job.total || 0))]),
              ]),
              _c("div", [
                _c("span", [_vm._v("Thành công")]),
                _c("strong", { staticClass: "sync-success" }, [
                  _vm._v(_vm._s(_vm.job.completed || 0)),
                ]),
              ]),
              _c("div", [
                _c("span", [_vm._v("Chờ thử lại")]),
                _c("strong", [_vm._v(_vm._s(_vm.job.waiting || 0))]),
              ]),
              _c("div", [
                _c("span", [_vm._v("Thất bại")]),
                _c("strong", { staticClass: "sync-error" }, [
                  _vm._v(_vm._s(_vm.job.failed || 0)),
                ]),
              ]),
              _c("div", [
                _c("span", [_vm._v("Chưa xử lý")]),
                _c("strong", [_vm._v(_vm._s(_vm.job.unprocessed || 0))]),
              ]),
            ]),
            _vm.running && _vm.job.currentUserName
              ? _c("p", [
                  _vm._v("Đang xử lý: "),
                  _c("strong", [_vm._v(_vm._s(_vm.job.currentUserName))]),
                  _vm.job.currentAction
                    ? _c("span", [_vm._v(" — " + _vm._s(_vm.actionLabel))])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.job.fingerprintWarnings
              ? _c("el-alert", {
                  attrs: {
                    title:
                      _vm.job.fingerprintWarnings +
                      " người có cảnh báo vân tay; các dữ liệu hợp lệ vẫn được lưu.",
                    type: "warning",
                    closable: false,
                    "show-icon": "",
                  },
                })
              : _vm._e(),
            _vm.job.cleanupPending
              ? _c("el-alert", {
                  attrs: {
                    title:
                      _vm.job.cleanupPending +
                      " người chưa xác nhận dọn xong dữ liệu trên thiết bị. Cần kiểm tra trước khi chạy lại.",
                    type: "error",
                    closable: false,
                    "show-icon": "",
                  },
                })
              : _vm._e(),
            !_vm.running && _vm.job.message
              ? _c("el-alert", {
                  attrs: {
                    title: _vm.job.message,
                    type: _vm.resultType,
                    closable: false,
                    "show-icon": "",
                  },
                })
              : _vm._e(),
            _vm.job.status === "PARTIAL"
              ? _c("p", { staticClass: "sync-muted" }, [
                  _vm._v(
                    "100% nghĩa là đã kết thúc lượt xử lý, vẫn còn người chưa đồng bộ thành công."
                  ),
                ])
              : _vm._e(),
            _vm.running
              ? _c("p", { staticClass: "sync-muted" }, [
                  _vm._v(
                    "Có thể đóng cửa sổ hoặc tải lại trang. Tác vụ tiếp tục chạy trên hệ thống."
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "sync-footer" },
              [
                _c("span", [
                  _vm._v(
                    "Cập nhật " +
                      _vm._s(_vm.updatedAgo) +
                      " giây trước · Mã " +
                      _vm._s(_vm.job.id)
                  ),
                ]),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "text",
                      size: "mini",
                      loading: _vm.loading,
                      disabled: _vm.loading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("refresh")
                      },
                    },
                  },
                  [_vm._v("Làm mới")]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }